export default __webpack_public_path__ + "static/media/v8.d36024d7.svg";